import React, { useEffect, useState } from "react";
import { Box, Typography, Link } from "@mui/material";
import { converOctateToType, getFileIcon } from "../../Utils/handler";
import { IconWrapper } from "./IconWrapper";

const fileTypes = {
    image: ["png", "jpg", "jpeg"],
    pdf: ["pdf"],
    doc: ["doc", "docx", "txt"],
    video: ["video-player"],
    audio: ["music"],
};

const isFileType = (iconName, type) => fileTypes[type]?.includes(iconName);

export default function DocPreview({ link, iconName, octateFile, height }) {
    const [convertedFile, setConvertedFile] = useState(null);


    useEffect(() => {
        if (isFileType(iconName, "pdf") && octateFile) {
            converOctateToType({ link, type: "application/pdf" }).then((blob) => {
                const binaryData = [blob];
                setConvertedFile(
                    window.URL.createObjectURL(
                        new Blob(binaryData, { type: "application/pdf" })
                    )
                );
            });
        }
    }, [link, iconName, octateFile]);

    if (isFileType(iconName, "image")) {
        return (
            <Box>
                <img width="100%" height={"auto"} style={{ pointerEvents: "none" }} src={link} loading="lazy" />
            </Box>
        );
    } else if (isFileType(iconName, "pdf")) {
        return (
            <Box flex="1" flexDirection="column">
                <iframe
                    allowFullScreen
                    width="500px"
                    style={{ border: "none", flex: 1 }}
                    height={'600px'}
                    src={octateFile ? convertedFile : link}
                    loading="lazy"
                />
            </Box>
        );
    } else if (isFileType(iconName, "doc")) {
        return (
            <Box flex="1" flexDirection="column">
                <iframe
                    allowFullScreen
                    width="100%"
                    style={{ border: "none", flex: 1 }}
                    height={height}
                    src={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(link)}`}
                    loading="lazy"
                />
            </Box>
        );
    } else if (isFileType(iconName, "video")) {
        return (
            <Box>
                <video
                    controls
                    src={link}
                    width="100%"
                    height="100%"
                    style={{ maxHeight: "400px" }}
                    loading="lazy"
                >
                    This video is not supported
                </video>
            </Box>
        );
    } else if (isFileType(iconName, "audio")) {
        return (
            <Box textAlign="center" pb={3}>
                <audio controls src={link}>
                    This audio is not supported
                </audio>
            </Box>
        );
    } else {
        return (
            <Box textAlign="center" p={1}>
                <IconWrapper icon={iconName} color="primary" fontSize="large" />
                <Typography>File Preview Not Supported</Typography>
                <Link
                    onClick={() => window.open(link, "_blank")}
                    sx={{ cursor: "pointer" }}
                >
                    Open in new tab
                </Link>
            </Box>
        );
    }
}